module.exports = __webpack_public_path__ + "36f9310251029999d8f4dfc89e5d257f.png";